import React, { useEffect, useMemo, useRef } from 'react'
import {
 Form, Input, Row, Col, Switch, Divider, Table
} from 'antd'
import NumberFormat from 'react-number-format';
import { useDebounce, useEffectOnce, useIsFirstRender, useIsMounted, useUpdateEffect } from 'usehooks-ts'
import Search from '../../components/Search'
import {
 currencyFormat, calculatePercent, percentageToDecimal, decimalToPercentage, getAmountsFromImporte, getBasePrice, getAmountsFromCost, percentageToCustomerTypePercentage, customerTypePercentageToPercentage,
} from '../../services/Utils'
import useCustomerTypePrice from './useCustomerTypePrice';
import debounce from 'lodash.debounce';

const CustomerPriceTypeInput = ({
    percentage, disabled, onChange, label, isGeneral
}) => {
    // console.log(percentage);
    // console.log(percentageToCustomerTypePercentage(percentage));
    // const realPercentage = parseFloat(percentageToCustomerTypePercentage(percentage));
    let realPercentage;
    if (isGeneral) {
        realPercentage = parseFloat(percentage);
    } else {
        realPercentage = parseFloat(percentageToCustomerTypePercentage(percentage)).toFixed(12);
    }


    // let formattedPercentage = realPercentage;
    // if (!isGeneral) {
    //     formattedPercentage = formattedPercentage.toFixed(6);
    // }

    return (
        <Form.Item label={label} hasFeedback>
            <NumberFormat
                decimalSeparator="."
                decimalScale={12}
                customInput={Input}
                style={{ width: '100%' }}
                value={realPercentage}
                placeholder="Escribe el porcentaje de mayoreo"
                addonAfter="%"
                disabled={disabled}
                onChange={onChange}
            />
        </Form.Item>
    );
};

const PanelPrices = ({
 product, change, prices, setPrices,
}) => {
    const isMounted = useIsMounted();
    const isFirstRender = useIsFirstRender();

    useEffect(() => {
        console.log('isMounted: ', isMounted);
        console.log('isFirstRender: ', isFirstRender);
    }, [isMounted, isFirstRender]);
    /**
     * Porcentaje para los diferentes tipos de cliente
     */
    const [customerPriceTypes, { savePercentage, calculateAll, calculateGeneral }] = useCustomerTypePrice(product.cost);
    const debouncedGeneral = useDebounce(customerPriceTypes.general.percentage, 800);
    const debouncedFranquicia = useDebounce(customerPriceTypes.franquicia.percentage, 800);
    const debouncedMayoreo = useDebounce(customerPriceTypes.mayoreo.percentage, 800);
    const debouncedMedioMayoreo = useDebounce(customerPriceTypes.mediomayoreo.percentage, 800);
    const debouncedFranquicia2 = useDebounce(customerPriceTypes.franquicia2.percentage, 800);
    const debouncedFranquicia3 = useDebounce(customerPriceTypes.franquicia3.percentage, 800);


    // console.log('customerPriceTypes: ', customerPriceTypes);
    // console.log('prices_: ', prices);

    /**
     * Precio final incluyendo impuestos
     */
    const [baseImporte, setBaseImporte] = React.useState(0);
    // const debouncedBaseImporte = useDebounce(baseImporte, 800)

    // Selected tax options
    const [selectedTax1, setSelectedTax1] = React.useState(0);
    const [selectedTax2, setSelectedTax2] = React.useState(0);

    // Taxes values
    const [taxDecimal1, setTaxDecimal1] = React.useState(0);
    const [taxDecimal2, setTaxDecimal2] = React.useState(0);

    // Others
    const [pageSize, setPageSize] = React.useState(17);
    const [disabled, setDisabled] = React.useState(false);

    const columnsCustomerPriceTypes = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Precio',
            dataIndex: 'price',
            key: 'price',
            render: (label, record) => currencyFormat(record.price),
        },
        {
            title: 'Primer impuesto',
            dataIndex: 'taxAmount1',
            key: 'taxAmount1',
            render: (label, record) => currencyFormat(record.taxAmount1),
        },
        {
            title: 'Segundo impuesto',
            dataIndex: 'taxAmount2',
            key: 'taxAmount2',
            render: (label, record) => currencyFormat(record.taxAmount2),
        },
        {
            title: 'Total',
            dataIndex: 'importe',
            key: 'importe',
            render: (label, record) => currencyFormat(record.importe),
        },
    ]

    const columnsPrices = [
        {
            title: 'Nombre de la sucursal',
            dataIndex: 'name',
            key: 'name',
            render: (label, record) => record.subsidiary.name + (record.subsidiary.logo_url === 'utilesa' ? ' (Utilesa)' : ''),
        },
        {
            title: 'Precio (con impuesto)',
            dataIndex: 'importe',
            key: 'importe',
            render: (label, record) => {
                return (
                    <NumberFormat
                    style={{ minWidth: '150px' }}
                    customInput={Input}
                    // thousandSeparator=","
                    decimalSeparator="."
                    decimalScale={2}
                    value={parseFloat(record.importe).toFixed(2)}
                    addonBefore="$"
                    placeholder="Precio"
                    onChange={e => {
                            const newPrices = [...prices];
                            const indexPrice = newPrices.findIndex(f => f.subsidiary_id === record.subsidiary_id);
                            if (indexPrice >= 0) {
                                const importe = +e.target.value;

                                const price = getBasePrice(importe, taxDecimal1 + taxDecimal2);
                                const taxAmount1 = price * (taxDecimal1);
                                const taxAmount2 = price * (taxDecimal2);

                                const priceType = { ...newPrices[indexPrice] };

                                priceType.price = price.toFixed(6);
                                priceType.tax = taxAmount1; // TODO: Deprecated
                                priceType.tax1 = taxAmount1.toFixed(6); // TODO: Migrar a taxAmount1
                                priceType.tax2 = taxAmount2.toFixed(6); // TODO: Migrar a taxAmount2
                                priceType.taxAmount1 = taxAmount1.toFixed(6);
                                priceType.taxAmount2 = taxAmount2.toFixed(6);
                                priceType.importe = importe.toFixed(6);

                                newPrices[indexPrice] = priceType;

                                setPrices(newPrices);
                            }
                    }}
                  />
                )
            },
        },
        {
            title: 'Precio (sin impuestos)',
            dataIndex: 'price',
            key: 'price',
            render: (label, record) => currencyFormat(record.price),
        },
        {
            title: 'Primer impuesto',
            dataIndex: 'taxAmount1',
            key: 'taxAmount1',
            render: (label, record) => currencyFormat(record.taxAmount1),
        },
        {
            title: 'Segundo impuesto',
            dataIndex: 'taxAmount2',
            key: 'taxAmount2',
            render: (label, record) => currencyFormat(record.taxAmount2),
        },
        {
            title: 'Activo',
            dataIndex: 'available_for_sale',
            key: 'available_for_sale',
            render: (label, record) => {
                return (
                    <Switch
                        defaultChecked={Boolean(record.available_for_sale)}
                        onChange={value => {
                            const newPrices = [...prices]
                            const indexPrice = newPrices.findIndex(f => f.subsidiary_id === record.subsidiary_id)
                            if (indexPrice >= 0) {
                                newPrices[indexPrice].available_for_sale = value
                                setPrices(newPrices)
                            }
                        }}
                    />
                )
            },
        },
    ]

    const getCalculatedPrices = (_baseImporte, _prices, _taxDecimal1, _taxDecimal2) => {
        if (!_baseImporte) {
            return _prices;
        }
        const {
            price, taxAmount1, taxAmount2,
        } = getAmountsFromImporte(_baseImporte, _taxDecimal1, _taxDecimal2, _taxDecimal1 + _taxDecimal2);

        return _prices.map(i => {
            const item = { ...i };

            if (item.subsidiary.logo_url === 'utilesa') {
                item.importe = _baseImporte * 1.1
                item.tax1 = taxAmount1 * 1.1
                item.tax2 = taxAmount2 * 1.1
                item.taxAmount1 = taxAmount1 * 1.1
                item.taxAmount2 = taxAmount2 * 1.1
                item.price = price * 1.1
            } else {
                    item.importe = _baseImporte.toFixed(6)
                    item.tax1 = taxAmount1.toFixed(6)
                    item.tax2 = taxAmount2.toFixed(6)
                    item.taxAmount1 = taxAmount1.toFixed(6)
                    item.taxAmount2 = taxAmount2.toFixed(6)
                    item.price = price.toFixed(6)
            }

            return item
        });
    }

    useEffect(() => {
        // setDisabled(!(product.cost > 0 && taxDecimal1 > 0));
        setDisabled(!(product.cost > 0));

    }, [product.cost, taxDecimal1]);

    useEffectOnce(() => {
        if (!product.id) {  //product is created
            savePercentage('general', decimalToPercentage(product.general));
            savePercentage('mayoreo', decimalToPercentage(product.mayoreo));
            savePercentage('mediomayoreo', decimalToPercentage(product.mediomayoreo));
            savePercentage('franquicia', decimalToPercentage(product.franquicia));
            savePercentage('franquicia2', decimalToPercentage(product.franquicia2));
            savePercentage('franquicia3', decimalToPercentage(product.franquicia3));
            return;
        }
        // product is editing
        let _taxDecimal1 = 0;
        if (product.tax_type_id && product.tax_type) {
            _taxDecimal1 = +product.tax_type.value
            setSelectedTax1(product.tax_type.name)
            setTaxDecimal1(_taxDecimal1)
        }

        let _taxDecimal2 = 0;
        if (product.tax_type_second_id && product.tax_type_second) {
            _taxDecimal2 = +product.tax_type_second.value
            setSelectedTax2(product.tax_type_second.name)
            setTaxDecimal2(_taxDecimal2)
        }

        savePercentage('mayoreo', decimalToPercentage(product.mayoreo));
        savePercentage('mediomayoreo', decimalToPercentage(product.mediomayoreo));
        savePercentage('franquicia', decimalToPercentage(product.franquicia));
        savePercentage('general', decimalToPercentage(product.general));
        savePercentage('franquicia2', decimalToPercentage(product.franquicia2));
        savePercentage('franquicia3', decimalToPercentage(product.franquicia3));

        const _baseImporte = product.base_price * (_taxDecimal1 + _taxDecimal2 + 1);

        if (_baseImporte > 0) {
            setBaseImporte(_baseImporte);
            setPrices(getCalculatedPrices(_baseImporte, prices, _taxDecimal1, _taxDecimal2))
            const _basePrice = getBasePrice(_baseImporte, _taxDecimal1 + _taxDecimal2);
            const _percentage = calculatePercent(product.cost, _basePrice);
            savePercentage('general', _percentage);
            change('general', percentageToDecimal(_percentage));
            change('base_price', _basePrice);
        }
    }, [product.id]);

    useEffect(() => {
        calculateAll(product.cost, taxDecimal1, taxDecimal2);
    }, [
        debouncedFranquicia,
        debouncedMayoreo,
        debouncedMedioMayoreo,
        debouncedGeneral,
        debouncedFranquicia2,
        debouncedFranquicia3,
        // taxDecimal1,
        // taxDecimal2,
        product.cost,
    ]);


    /**
     * Change baseImporte
     */
    useUpdateEffect(() => {
        const result = getAmountsFromCost(product.cost, customerPriceTypes.general.percentage, taxDecimal1, taxDecimal2, taxDecimal1 + taxDecimal2);
        if (result.importe >= 0) {
            setBaseImporte(result.importe);
            const basePrice = getBasePrice(result.importe, taxDecimal1 + taxDecimal2);
            change('base_price', basePrice);
            setPrices(getCalculatedPrices(result.importe, prices, taxDecimal1, taxDecimal2));
        }
    }, [debouncedGeneral])

    useEffect(() => {
        // if (product.freight && product.cost_without_freight) {
             if (product.cost_without_freight && product.cost_without_freight > 0) {
                const decimalFreight = product.freight / 100;
                console.log("product.freight",decimalFreight)
                if (decimalFreight) {
                    const newCost = product.cost_without_freight * (decimalFreight + 1)
                    change('cost', newCost)
                } else {
                    change('cost', product.cost_without_freight)
                }
            //  }
        }
    }, [product.freight, product.cost_without_freight]);

    useEffect(() => {
        const utilesaPrices = prices.filter(price => price.subsidiary.logo_url === 'utilesa');
        const otherPrices = prices.filter(price => price.subsidiary.logo_url !== 'utilesa');
        const dataSourcePrices = [...otherPrices, ...utilesaPrices];
        setPageSize(otherPrices.length);
        setPrices(dataSourcePrices);
    }, []);

    const handleCustomerTypePriceChange = (type, customerTypePercentage) => {
        const percentage = customerTypePercentageToPercentage(customerTypePercentage); // type === 'general' ? customerTypePercentage : customerTypePercentageToPercentage(customerTypePercentage);
        const decimal = percentageToDecimal(percentage);
        savePercentage(type, percentage);
        change(type, decimal);
    }

    const handleBaseImporteChange = (e) => {
        const _baseImporte = +e.target.value
        setBaseImporte(_baseImporte)

        const _basePrice = getBasePrice(_baseImporte, taxDecimal1 + taxDecimal2);
        const _percentage = calculatePercent(product.cost, _basePrice);

        change('base_price', _basePrice);
        savePercentage('general', _percentage);
        setPrices(getCalculatedPrices(_baseImporte, prices, taxDecimal1, taxDecimal2))
    }

    const debouncedHandleCustomerTypePriceChange = useMemo(() => debounce(handleCustomerTypePriceChange, 800), [product]);

    // const debouncedHandleBaseImporteChange = useMemo(() => debounce(handleBaseImporteChange, 800), [taxDecimal1, taxDecimal2, product.cost, prices]);

    return (
        <>
            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Col lg={8} md={12} sm={24}>
                        <Form.Item label="Costo" hasFeedback className="required">
                            <NumberFormat
                                decimalSeparator="."
                                decimalScale={2}
                                customInput={Input}
                                style={{ width: '100%' }}
                                addonBefore="$"
                                value={product.cost_without_freight === 0 ? "" : product.cost_without_freight}
                                placeholder="Escribe el costo"
                                onChange={e => {
                                    change('cost_without_freight', +e.target.value || 0)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={8} md={12} sm={24}>
                        <Form.Item label="Flete" hasFeedback>
                            <NumberFormat
                                decimalSeparator="."
                                decimalScale={2}
                                customInput={Input}
                                style={{ width: '100%' }}
                                addonAfter="%"
                                value={product.freight  === 0 ? "" : product.freight}
                                // onKeyPress={e => onKeyMoney(e, product.freight)}
                                placeholder="Escribe el flete"
                                onChange={e => {
                                    change('freight', +e.target.value || 0)
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={8} md={12} sm={24}>
                        <Form.Item label="Costo final " hasFeedback>
                            <NumberFormat
                                decimalSeparator="."
                                decimalScale={2}
                                customInput={Input}
                                style={{ width: '100%' }}
                                addonBefore="$"
                                // onKeyPress={e => onKeyMoney(e, product.cost)}
                                value={product.cost}
                                disabled
                                placeholder="Escribe el costo"
                            />
                        </Form.Item>
                    </Col>
                </Col>

                <Col lg={12} md={24} sm={24}>
                    <Col lg={12} md={24} sm={24}>
                        <Form.Item className="required" label="Primer impuesto">
                            <Search
                                value={selectedTax1}
                                placeholder="Busca un tipo de impuesto"
                                onSearch={value => `/api/tax_types?filter[name]=${value}`}
                                onChange={(key, value) => {
                                    change('tax_type_id', key)
                                    setSelectedTax1(value.name)
                                    setTaxDecimal1(+value.value)
                                    setPrices(getCalculatedPrices(baseImporte, prices, +value.value, taxDecimal2))
                                    calculateAll(product.cost, +value.value, taxDecimal2);
                                    
                                    const _basePrice = getBasePrice(baseImporte, +value.value + taxDecimal2);
                                    change('base_price', _basePrice);

                                    calculateGeneral(product.cost, +value.value, taxDecimal2, _basePrice, baseImporte);
                                }}
                                getCollector={value => {
                                    if(!product.id || product.tax_type_id === null || product.tax_type_id === 0){
                                        if (value) {
                                            const newValue = value.find(item => item.name === "EXENTO");
                                            if(newValue){
                                                setSelectedTax1(newValue.name);
                                                setTaxDecimal1(+newValue.value)
                                                console.log('newValue', newValue.id)
                                                change('tax_type_id', newValue.id);
                                            }
                                        }
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>

                    <Col lg={12} md={24} sm={24}>
                        <Form.Item label="Segundo impuesto">
                            <Search
                                value={selectedTax2}
                                placeholder="Busca un tipo de impuesto"
                                onSearch={value => `/api/tax_types?filter[name]=${value}`}
                                onChange={(key, value) => {
                                    change('tax_type_second_id', key);
                                    setSelectedTax2(value.name)
                                    setTaxDecimal2(+value.value)
                                    setPrices(getCalculatedPrices(baseImporte, prices, taxDecimal1, +value.value))
                                    calculateAll(product.cost, taxDecimal1, +value.value);

                                    const _basePrice = getBasePrice(baseImporte, taxDecimal1 + +value.value);
                                    change('base_price', _basePrice);

                                    calculateGeneral(product.cost, taxDecimal1, +value.value, _basePrice, baseImporte);
                                }}
                                getCollector={value => {
                                    if(!product.id || product.tax_type_second_id === null || product.tax_type_second_id === 0){
                                        if (value) {
                                            const newValue = value.find(item => item.name === "EXENTO");
                                            if(newValue){
                                                setSelectedTax2(newValue.name);
                                                setTaxDecimal2(+newValue.value)
                                                change('tax_type_second_id', newValue.id);
                                            }
                                        }
                                    }
                                }}
                            />
                        </Form.Item>
                    </Col>
                </Col>
            </Row>

            <Row gutter={24}>
                <Col lg={12} md={24} sm={24}>
                    <Divider>Precio en sucursales</Divider>
                    <Row gutter={24}>
                        <Col lg={12} md={24} sm={24}>
                            <Form.Item label="Precio (con impuestos)" hasFeedback>
                                <NumberFormat
                                    decimalSeparator="."
                                    decimalScale={2}
                                    customInput={Input}
                                    addonBefore="$"
                                    style={{ width: '100%' }}
                                    value={parseFloat(baseImporte).toFixed(2)}
                                    disabled={disabled}
                                    placeholder="Escribe el precio"
                                    onChange={handleBaseImporteChange}
                                />
                            </Form.Item>
                        </Col>

                        <Col lg={12} md={24} sm={24}>
                            <Form.Item label="Precio (sin impuestos)" hasFeedback>
                                <NumberFormat
                                   decimalSeparator="."
                                   decimalScale={2}
                                   customInput={Input}
                                    addonBefore="$"
                                    style={{ width: '100%' }}
                                    value={parseFloat(product.base_price).toFixed(2)}
                                    disabled
                                    placeholder="Escribe el precio"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Table rowKey={record => record.subsidiary_id} dataSource={prices} columns={columnsPrices} pagination={{ pageSize }} />
                </Col>

                <Col lg={12} md={24} sm={24}>
                    <Divider>Precios de venta</Divider>
                    <Row gutter={24}>
                        <Col lg={6} md={12} sm={24}>
                            <CustomerPriceTypeInput
                                label="Público general"
                                percentage={customerPriceTypes.general.percentage}
                                placeholder="Escribe el porcentaje de general"
                                disabled={disabled}
                                onChange={e => debouncedHandleCustomerTypePriceChange('general', +e.target.value)}
                                // isGeneral fix percentage
                            />
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <CustomerPriceTypeInput
                                label="Franquicia"
                                percentage={customerPriceTypes.franquicia.percentage}
                                placeholder="Escribe el porcentaje de franquicia"
                                disabled={disabled}
                                onChange={e => debouncedHandleCustomerTypePriceChange('franquicia', +e.target.value)}
                            />
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <CustomerPriceTypeInput
                                label="Medio mayoreo"
                                percentage={customerPriceTypes.mediomayoreo.percentage}
                                placeholder="Escribe el porcentaje de medio mayoreo"
                                disabled={disabled}
                                onChange={e => debouncedHandleCustomerTypePriceChange('mediomayoreo', +e.target.value)}
                            />
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <CustomerPriceTypeInput
                                label="Mayoreo"
                                percentage={customerPriceTypes.mayoreo.percentage}
                                placeholder="Escribe el porcentaje de mayoreo"
                                disabled={disabled}
                                onChange={e => debouncedHandleCustomerTypePriceChange('mayoreo', +e.target.value)}
                            />
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <CustomerPriceTypeInput
                                label="Franquicia 2"
                                percentage={customerPriceTypes.franquicia2.percentage}
                                placeholder="Escribe el porcentaje de franquicia 2"
                                disabled={disabled}
                                onChange={e => debouncedHandleCustomerTypePriceChange('franquicia2', +e.target.value)}
                            />
                        </Col>
                        <Col lg={6} md={12} sm={24}>
                            <CustomerPriceTypeInput
                                label="Franquicia 3"
                                percentage={customerPriceTypes.franquicia3.percentage}
                                placeholder="Escribe el porcentaje de franquicia 3"
                                disabled={disabled}
                                onChange={e => debouncedHandleCustomerTypePriceChange('franquicia3', +e.target.value)}
                            />
                        </Col>
                    </Row>

                    <Table
                        rowKey={record => record.name}
                        dataSource={[
                            customerPriceTypes.general,
                            customerPriceTypes.franquicia,
                            customerPriceTypes.mediomayoreo,
                            customerPriceTypes.mayoreo,
                            customerPriceTypes.franquicia2,
                            customerPriceTypes.franquicia3,
                        ]}
                        columns={columnsCustomerPriceTypes}
                    />
                </Col>
            </Row>
        </>
    )
}
export default PanelPrices
